"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.key = exports.appStoreMenus = exports.WIDGET_ROLES = exports.WIDGET_CONSTANTS = exports.UPDATE_PROFILE_IMAGE = exports.UPDATE_DEPARTMENT = exports.UPDATE_BRANDS = exports.UPDATE_APPS = exports.SIDENAV_TOGGLE = exports.SIDENAV_SHOW = exports.SIDENAV_MENU = exports.SIDENAV_HIDE = exports.SET_USER_GRID_COLUMNS = exports.SET_SHOW_TODO = exports.SET_PERSONA_FOR_USER = exports.SET_JWTTOKENSN = exports.SET_ENTITLEMENT_STATUS = exports.SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.LOADING = exports.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR = exports.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.GET_USER_SESSION_TOKEN = exports.GET_USER_SESSION = exports.GET_USER_GRID_COLUMNS = exports.GET_USERAPPS_SUCCESS = exports.GET_USERAPPS_ERROR = exports.GET_USERAPPS = exports.GET_PERSONA_FOR_USER = exports.GET_PERSONA = exports.FINDBYUSERAPPANDFUNCTIONS_SUCCESS = exports.FINDBYUSERAPPANDFUNCTIONS_ERROR = exports.FINDBYUSERAPPANDFUNCTIONS = exports.FETCH_JWTTOKENSN = exports.ENTITLEMENT_STATUS = exports.COMMON_SERVICE_SUCCESS = exports.COMMON_SERVICE_ERROR = exports.COMMON_SERVICE = exports.AUTHENTICATION = exports.APPLY_USER_GRID_SETTING = exports.ACTION_TRACKING_MYSELF_PAGED_KEY = void 0;
const key = exports.key = "base-layout";
function slashMerge() {
  return Array.from(arguments).join("/");
}
const baseUrl = slashMerge("estee-lauder", key);
const LOADING = exports.LOADING = slashMerge(baseUrl, "LOADING");
const SIDENAV_TOGGLE = exports.SIDENAV_TOGGLE = slashMerge(baseUrl, "SIDENAV_TOGGLE");
const SIDENAV_SHOW = exports.SIDENAV_SHOW = slashMerge(baseUrl, "SIDENAV_SHOW");
const SIDENAV_HIDE = exports.SIDENAV_HIDE = slashMerge(baseUrl, "SIDENAV_HIDE");
const SIDENAV_MENU = exports.SIDENAV_MENU = slashMerge(baseUrl, "SIDENAV_MENU");
const AUTHENTICATION = exports.AUTHENTICATION = slashMerge(baseUrl, "AUTHENTICATION");
const UPDATE_APPS = exports.UPDATE_APPS = slashMerge(baseUrl, "UPDATE_APPS");
const FINDBYUSERAPPANDFUNCTIONS = exports.FINDBYUSERAPPANDFUNCTIONS = slashMerge(baseUrl, "FINDBYUSERAPPANDFUNCTIONS");
const FINDBYUSERAPPANDFUNCTIONS_SUCCESS = exports.FINDBYUSERAPPANDFUNCTIONS_SUCCESS = slashMerge(baseUrl, "FINDBYUSERAPPANDFUNCTIONS_SUCCESS");
const FINDBYUSERAPPANDFUNCTIONS_ERROR = exports.FINDBYUSERAPPANDFUNCTIONS_ERROR = slashMerge(baseUrl, "FINDBYUSERAPPANDFUNCTIONS_ERROR");
const GET_USERAPPS = exports.GET_USERAPPS = slashMerge(baseUrl, "GET_USERAPPS");
const GET_USERAPPS_SUCCESS = exports.GET_USERAPPS_SUCCESS = slashMerge(baseUrl, "GET_USERAPPS_SUCCESS");
const GET_USERAPPS_ERROR = exports.GET_USERAPPS_ERROR = slashMerge(baseUrl, "GET_USERAPPS_ERROR");
const UPDATE_BRANDS = exports.UPDATE_BRANDS = slashMerge(baseUrl, "UPDATE_BRANDS");
const SET_SHOW_TODO = exports.SET_SHOW_TODO = slashMerge(baseUrl, "SET_SHOW_TODO");
const UPDATE_DEPARTMENT = exports.UPDATE_DEPARTMENT = slashMerge(baseUrl, "UPDATE_DEPARTMENT");
const UPDATE_PROFILE_IMAGE = exports.UPDATE_PROFILE_IMAGE = slashMerge(baseUrl, "UPDATE_PROFILE_IMAGE");
const SET_ENTITLEMENT_STATUS = exports.SET_ENTITLEMENT_STATUS = slashMerge(baseUrl, "SET_ENTITLEMENT_STATUS");
const FETCH_JWTTOKENSN = exports.FETCH_JWTTOKENSN = slashMerge(baseUrl, "FETCH_JWTTOKENSN");
const SET_JWTTOKENSN = exports.SET_JWTTOKENSN = slashMerge(baseUrl, "SET_JWTTOKENSN");
const GET_USER_SESSION = exports.GET_USER_SESSION = slashMerge(baseUrl, "GET_USER_SESSION");
const GET_USER_SESSION_TOKEN = exports.GET_USER_SESSION_TOKEN = slashMerge(baseUrl, "GET_USER_SESSION_TOKEN");
const GET_PERSONA = exports.GET_PERSONA = slashMerge(baseUrl, "GET_PERSONA");
const GET_PERSONA_FOR_USER = exports.GET_PERSONA_FOR_USER = slashMerge(baseUrl, "GET_PERSONA_FOR_USER");
const SET_PERSONA_FOR_USER = exports.SET_PERSONA_FOR_USER = slashMerge(baseUrl, "SET_PERSONA_FOR_USER");
const ENTITLEMENT_STATUS = exports.ENTITLEMENT_STATUS = "ENTITLEMENT_STATUS";
const COMMON_SERVICE = exports.COMMON_SERVICE = slashMerge(key, "COMMON_SERVICE");
const COMMON_SERVICE_SUCCESS = exports.COMMON_SERVICE_SUCCESS = slashMerge(key, "COMMON_SERVICE_SUCCESS");
const COMMON_SERVICE_ERROR = exports.COMMON_SERVICE_ERROR = slashMerge(key, "COMMON_SERVICE_ERROR");
const IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = slashMerge(key, "IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED");
const IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR = exports.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR = slashMerge(key, "IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR");
const SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = slashMerge(key, "SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED");
const LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = exports.LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED = slashMerge(key, "LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED");
const GET_USER_GRID_COLUMNS = exports.GET_USER_GRID_COLUMNS = slashMerge(key, "GET_USER_GRID_COLUMNS");
const SET_USER_GRID_COLUMNS = exports.SET_USER_GRID_COLUMNS = slashMerge(key, "SET_USER_GRID_COLUMNS");
const APPLY_USER_GRID_SETTING = exports.APPLY_USER_GRID_SETTING = slashMerge(key, "APPLY_USER_GRID_SETTING");
const appStoreMenus = exports.appStoreMenus = {
  menuList: []
};

// export const constructImageUrl = email =>
//   `https://outlook.office365.com/owa/service.svc/s/GetPersonaPhoto?email=${email}&UA=0&size=HR64x64`;

const WIDGET_ROLES = exports.WIDGET_ROLES = {
  ADMIN: "ADMIN",
  GCS_PDM: "GCS_PDM",
  GCS_PDM_SUPER_USER: "GCS_PDM_SUPER_USER",
  READ_ONLY: "READ_ONLY",
  GCS_CUST_SVC_SU: "GCS_CUST_SVC_SU",
  GCS_CUST_SVC: "GCS_CUST_SVC",
  PLN_READONLY: "PLN_READONLY",
  MSM: "MSM",
  PDM_READONLY: "PDM_READONLY",
  RB_TSO_ENGINEER: "RB_TSO_ENGINEER",
  RB_MANUFACTURE_USER: "RB_MANUFACTURE_USER"
};
const WIDGET_CONSTANTS = exports.WIDGET_CONSTANTS = {
  GCS: "GCS",
  MKB: "MKB",
  GROUP_STATISTICS: "GROUP_STATISTICS",
  COL_SPAN: "COL_SPAN",
  RB_GREEN: "Green",
  RB_Yellow: "Yellow",
  RB_RED: "Red",
  RB_ORANGE: "Orange",
  RB_FAVORITES: "Favorites",
  RB: "RB",
  EMPTY_RECIPE_NAME: "Empty Recipe Name"
};
const ACTION_TRACKING_MYSELF_PAGED_KEY = exports.ACTION_TRACKING_MYSELF_PAGED_KEY = "VWFWACTSLF";